export default "__VITE_ASSET__CGKisqbJ__"